import { PMUSSettings, PMUSTypes } from "../PMUS/PMUSSettings";

export class PMUSNeutralSettings {
  constructor(c = {}) {
    const settings = {
      ...new PMUSSettings(c),
      neutralButtonBackgroundColor: 'gray',
      neutralButtonFontColor: 'white',

      onButtonBackgroundColor: 'green',
      onButtonFontColor: 'white',
      onButtonText: 'Accept',

      offButtonBackgroundColor: 'red',
      offButtonFontColor: 'white',
      offButtonText: 'Reject',

      requiredConsentText: "Required For Consent",
      requiredConsentLetter: "R",
    }

    Object.assign(this, settings, c)
  }
}

export const PMUSNeutralTypes = {
  ...PMUSTypes,
  'toggle settings': {
    neutralButtonBackgroundColor: { title: 'Neutral Button Background Color', type: 'ColorPicker' },
    neutralButtonFontColor: { title: 'Neutral Button Font Color', type: 'ColorPicker' },

    onButtonBackgroundColor: { title: 'On Button Background Color', type: 'ColorPicker' },
    onButtonFontColor: { title: 'ON Button Font Color', type: 'ColorPicker' },
    onButtonText: { title: 'ON Button Text', type: 'InputLanguage' },

    offButtonBackgroundColor: { title: 'Off Button Background Color', type: 'ColorPicker' },
    offButtonFontColor: { title: 'Off Button Font Color', type: 'ColorPicker' },
    offButtonText: { title: 'Off Button Text!', type: 'InputLanguage' },

    requiredConsentText: { title: 'Required Consent Tag Text', type: 'InputLanguage' },
  }
}